import { Platform } from "./platform.interface";

export const YAMPI: Platform = {
  id: '0197184d-68f3-7432-abd4-b1eb07ad5232',
  name: 'Yampi',
  slug: 'yampi',
  uri: 'yampi.com.br'
};